<h2
  mat-dialog-title
  class="display-flex align-items-center"
  cdkDrag
  cdkDragHandle
  cdkDragRootElement=".cdk-overlay-pane"
  [cdkDragDisabled]="isBlockDraggable"
>
  <ng-container *ngIf="!isLoading; else headerLoading">
    <div class="display-flex flex-column grid-gap-8 flex-grow-1">
      <div class="display-flex align-items-center">
        <app-template-editor-header
          (mouseout)="isBlockDraggable = false"
          (mouseover)="isBlockDraggable = true"
          [header]="inspectionTemplate.name"
          (headerChanged)="headerChange($event)"
        ></app-template-editor-header>
        <span class="action-buttons" (mouseout)="isBlockDraggable = false" (mouseover)="isBlockDraggable = true">
          <button mat-icon-button (click)="removeTemplate()">
            <app-icon [svg]="EIcon.BB_TRASH"></app-icon>
          </button>
        </span>

        <button class="ml-auto" mat-button (click)="add()">
          <span class="display-flex align-items-center justify-content-center add-button">
            <mat-icon [inline]="true" class="add-button__icon">add</mat-icon>
            <span class="add-button__text">add area</span>
          </span>
        </button>
      </div>
    </div>
  </ng-container>

  <ng-template #headerLoading>
    <app-skeleton-loader class="w-100 h-100 header-loader"></app-skeleton-loader>
  </ng-template>

  <button
    mat-icon-button
    class="ml-auto"
    (click)="cancel()"
    (mouseout)="isBlockDraggable = false"
    (mouseover)="isBlockDraggable = true"
  >
    <mat-icon>clear</mat-icon>
  </button>
</h2>
<mat-dialog-content>
  <div class="template-editor-inspection-dnd-content" cdkDropListGroup>
    <div
      cdkDropList
      (cdkDropListEntered)="enter($event)"
      (cdkDropListDropped)="dropArea(inspectionTemplateContent.areas)"
      #placeholder
    ></div>
    <ng-container *ngIf="!isItemsLoading; else spinnerTemplate">
      <div
        cdkDropList
        (cdkDropListEntered)="enter($event)"
        (cdkDropListDropped)="dropArea(inspectionTemplateContent.areas)"
        *ngFor="let area of inspectionTemplateContent?.areas; trackBy: trackById.bind(this, 'id')"
      >
        <div cdkDragBoundary=".template-editor-inspection-dnd-content" cdkDrag appDragCursor>
          <app-template-editor-area
            [area]="area"
            (areaChange)="areaChange($event)"
            (enterPressed)="enterPressed($event)"
            (remove)="remove($event)"
          ></app-template-editor-area>
        </div>
      </div>
    </ng-container>
  </div>
  <div #endListPlaceholder></div>

  <ng-template #spinnerTemplate>
    <div class="spinner-container">
      <app-skeleton-loader class="w-100 h-100"></app-skeleton-loader>
    </div>
  </ng-template>
</mat-dialog-content>
